import { Box } from "@mui/material";

const rows = [
  [
    "상호명 : 프롭레이크",
    "사업자등록번호 : 245-31-02022",
    "대표자명 : 김효동",
    "통신판매업신고번호 : 2026-성남분당B-0931",
  ],
  [
    "Email : proplake.rich@gmail.com",
    "사업장 주소 : 경기도 성남시 분당구 황새울로342번길 21, 6층 비49호",
  ],
];

export const BusinessFooter = () => (
  <Box component="footer" aria-label="사업자 정보" sx={{
    flexShrink: 0,
    px: { xs: 1.5, desktop: 2 },
    py: 0.75,
    borderTop: 1,
    borderColor: "divider",
    bgcolor: "background.paper",
    color: "text.secondary",
    fontSize: 11,
    lineHeight: 1.7,
    textAlign: "left",
    overflowWrap: "anywhere",
  }}>
    {rows.map((row, index) => (
      <Box key={index} sx={{ display: "flex", flexWrap: "wrap", columnGap: 1 }}>
        {row.map((item, itemIndex) => (
          <Box key={itemIndex} component="span">
            {itemIndex > 0 && <Box component="span" aria-hidden="true" sx={{ mr: 1 }}>|</Box>}
            {item}
          </Box>
        ))}
      </Box>
    ))}
  </Box>
);
